import React, {useRef} from 'react';
import {StyleSheet, View} from 'react-native';
import ENV from '../../../../../environment';

const {ZOOM_IFRAME_BASE_URL} = ENV;

interface ZoomMeetingInfo {
  meetingId: string;
  tk: string;
  pwd: string;
  signature: string;
  userName: string;
  userEmail: string;
}
interface IframeZoomProps {
  zoomMeetingInfo: ZoomMeetingInfo;
}

const IframeZoom: React.FC<IframeZoomProps> = ({zoomMeetingInfo}) => {
  const iframeRef = useRef<HTMLIFrameElement | null>(null);

  const iframeSrc =
    `${ZOOM_IFRAME_BASE_URL}/?zoomEmbed=true` + //later just change it prod ccl
    `&meetingId=${encodeURIComponent(zoomMeetingInfo.meetingId)}` +
    `&tk=${encodeURIComponent(zoomMeetingInfo.tk)}` +
    `&pwd=${encodeURIComponent(zoomMeetingInfo.pwd)}` +
    `&signature=${encodeURIComponent(zoomMeetingInfo.signature)}` +
    `&userName=${encodeURIComponent(zoomMeetingInfo.userName)}` +
    `&userEmail=${encodeURIComponent(zoomMeetingInfo.userEmail)}`;

  return (
    <View style={styles.container}>
      <iframe
        ref={iframeRef}
        src={iframeSrc}
        style={{
          border: 0,
          width: '100%',
          height: '100%',
          // overflow: 'hidden',
          position: 'absolute',
          top: 0,
          left: 0,
        }}
        allow="camera; microphone" //; fullscreen"
        title="Zoom Meeting"
      />
    </View>
  );
};

export default IframeZoom;

const styles = StyleSheet.create({
  container: {
    position: 'relative',
    paddingHorizontal: 'auto',
    width: '100%',
    height: '100%',
    aspectRatio: 4 / 3, // Equivalent to paddingTop: '56.25%'
  },
});
